<template>
  <v-row>
    <v-col cols="12" lg="4" offset-lg="4" md="6" offset-md="6">
      <v-card class="elevation-12 mt-3 pb-3 mx-1 text-center">
        <v-toolbar color="primary" dark flat>
          {{ pageTitle }}
        </v-toolbar>

        <v-card-text>
          <v-text-field v-model="mailUid"
                        label="Идентификатор письма"
                        @keyup.enter="onMailUidKepUpEnter"
                        ref="mailUid"
          />
        </v-card-text>

        <template v-if="isMailLoaded">
          <template v-if="mail.isPerformed">
            <h3 class="mb-5 brown darken-2 white--text">Текущий статус: {{ mail.perform.performType.name }}</h3>
          </template>


          <template v-if="mail.isPacked">
            <h3 class="blue--text darken-1">Пост пакет: {{ mail.postPackage.uid }}</h3>
            <h3 class="red--text darken-4">{{ mail.uid }}</h3>
            <h3>{{ mail.receiver }}</h3>
            <h3>{{ mail.fullAddress }}</h3>

            <div class="text-center mt-5">
              <template v-if="isAllowUnsetPostPackageMail">
                <v-btn class="error my-1" @click="unsetPostPackageDialog = true">Досыл (Бошқа манзилга юбориш)</v-btn>

                <v-dialog v-model="unsetPostPackageDialog" max-width="600px" :persistent="true">
                  <MailUnsetPostPackage @close="unsetPostPackageDialog = false" :mail="mail"/>
                </v-dialog>
              </template>

<!--              <template v-if="isAllowTryPerform">-->
<!--                <v-btn color="info" class="ml-1" @click="tryPerformDialog = true">Попытка вручения (Етказиб беришга уриниш)</v-btn>-->
<!--                <v-dialog v-model="tryPerformDialog" max-width="600px" :persistent="true">-->
<!--                  <TryPerform @close="tryPerformDialog = false" :mail="mail" ref="tryPerform"/>-->
<!--                </v-dialog>-->
<!--              </template>-->

<!--              <template v-if="isAllowDeliveryPerform">-->
<!--                <v-btn class="ml-1" color="success" @click="deliveredDialog = true">-->
<!--                  Вручено (Топширилди)-->
<!--                </v-btn>-->

<!--                <v-dialog v-model="deliveredDialog" max-width="600px" :persistent="true">-->
<!--                  <SuccessDeliveredPerform @close="deliveredDialog = false" :mail-history="histories" :mail="mail" ref="successDeliveredPerform"/>-->
<!--                </v-dialog>-->
<!--              </template>-->

<!--              <template v-if="isAllowFailedPerform">-->
<!--                <v-btn color="error" class="ml-1" @click="failedDialog = true">-->
<!--                  Возврат (Қайтариш)-->
<!--                </v-btn>-->
<!--                <v-dialog v-model="failedDialog" max-width="800px" :persistent="true">-->
<!--                  <FailedDeliveryPerform @close="failedDialog = false" :mail-history="histories" :mail="mail" ref="failedDeliveredPerform"/>-->
<!--                </v-dialog>-->
<!--              </template>-->
            </div>
          </template>
          <template v-else>
            <h3 class="orange--text">Письмо не сформировано ещё</h3>
          </template>
        </template>

        <v-snackbar v-model="isMailNotFound"
                    :timeout="5000"
                    :bottom="true"
                    color="error"
        >
          Письмо не найдено
        </v-snackbar>

        <v-snackbar v-model="isSuccessPerformed"
                    :timeout="5000"
                    :bottom="true"
                    color="info"
        >
          Результат успешно сохранен
        </v-snackbar>

        <v-snackbar v-model="isSuccessUnsetPostPackage"
                    :timeout="5000"
                    :bottom="true"
                    color="info"
        >
          Досыл успешно сохранен
        </v-snackbar>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import MailService from '@/services/mail.service'
import Mappers from "@/mappers";
import {required} from 'vuelidate/lib/validators'
import MailUnsetPostPackage from "@/components/mail/MailUnsetPostPackage";
import {APP_MAIL_PERFORMED, APP_MAIL_UNSET_POST_PACKAGE} from "@/events/app";
import _ from "underscore";
import {AllowDeleteFromPostPackage} from "@/enums/permission";

export default {
  name: "MailsPerformView",
  components: {
    MailUnsetPostPackage
  },
  data() {
    return {
      mailUid: '',
      mail: null,
      loading: false,
      histories: [],

      deliveredDialog: false,
      failedDialog: false,
      tryPerformDialog: false,
      unsetPostPackageDialog: false,

      isMailNotFound: false,
      isSuccessPerformed: false,
      isSuccessUnsetPostPackage: false
    }
  },
  validations: {
    mailUid: {
      required
    }
  },
  computed: {
    pageTitle() {
      return `Ввод результата`
    },
    isMailLoaded() {
      return this.mail !== null
    },
    isAllowFailedPerform() {
      return this.mail.allowFailedPerform || this.$store.getters.appIsOperatorLogin
    },
    isAllowDeliveryPerform() {
      return this.mail.allowDeliveryPerform || this.$store.getters.appIsOperatorLogin
    },
    isAllowTryPerform() {
      return this.mail.allowTryPerform || this.$store.getters.appIsOperatorLogin
    },
    isAllowUnsetPostPackageMail() {
      return this.mail.allowUnsetPostPackage && !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeleteFromPostPackage
      })
    },
  },
  methods: {
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },
    loadMail(uid) {
      this.mail = null
      this.isMailNotFound = false

      this.loading = true
      this.$store.dispatch(LAYOUT_LOADING_START)
      MailService.get(uid)
          .then(response => {
            this.mailUid = ''
            this.$v.$reset()

            this.mail = Mappers.mapMail(response.data)
          }, () => {
            this.isMailNotFound = true
          })
          .catch(() => {
            this.isMailNotFound = true
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onMailUidKepUpEnter() {
      this.$v.$touch()
      this.mailUid = this.mailUid.trim()

      if (!this.$v.$invalid) {
        this.loadMail(this.mailUid)
        this.loadHistories(this.mailUid)
      }
    },
    loadHistories(mailUid) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      MailService.getHistories(mailUid)
          .then(response => {
            this.histories = _.map(response.data, mailHistoryViewModel => {
              return Mappers.mapMailHistory(mailHistoryViewModel)
            })
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onMailPerformed() {
      this.$refs.successDeliveredPerform && this.$refs.successDeliveredPerform.clear()
      this.$refs.failedDeliveredPerform && this.$refs.failedDeliveredPerform.clear()
      this.$refs.tryPerform && this.$refs.tryPerform.clear()

      this.$nextTick(() => {
        this.deliveredDialog = false
        this.failedDialog = false
        this.tryPerformDialog = false
      })

      this.isSuccessPerformed = true
      this.clear()
    },
    onUnsetPostPackage() {
      this.unsetPostPackageDialog = false

      this.isSuccessUnsetPostPackage = true
      this.clear()
    },

    clear() {
      this.mailUid = ''
      this.mail = null
      this.$v.$reset()

      this.$refs.mailUid.focus()
    }
  },
  created() {
    this.setPageTitle()

    this.$bus.$on(APP_MAIL_PERFORMED, this.onMailPerformed)
    this.$bus.$on(APP_MAIL_UNSET_POST_PACKAGE, this.onUnsetPostPackage)
  },
  beforeDestroy() {
    this.$bus.$off(APP_MAIL_PERFORMED, this.onMailPerformed)
    this.$bus.$off(APP_MAIL_UNSET_POST_PACKAGE, this.onUnsetPostPackage)
  },
  mounted() {
    this.$refs.mailUid.focus()
  }
}
</script>

<style scoped>

</style>
